import React, { useEffect, useState, useCallback  } from "react";
import { apiClient } from "../utils/const";
import DeleteWithdrawal from "./DeleteWithdrawal";
import EditWithdrawal from "./EditWithdrawal";
import AddWithdrawal from "./AddWithdrawal";

const WithdrawalList = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [editingWithdrawalId, setEditingWithdrawalId] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);

    const [schemeType, setSchemeType] = useState(
        () => localStorage.getItem("schemeType") || "mandal"
    );

    const fetchUsers = useCallback (() => {
        setLoading(true);
        setError(null);

        const endpoint =
            schemeType === "mandal"
                ? "/fetch_mandal_withdrawals.php"
                : "/fetch_kanchan_withdrawals.php";

        apiClient
            .post(endpoint)
            .then((res) => {
                if (res.data && Array.isArray(res.data.withdrawals)) {
                    setUsers(res.data.withdrawals);
                } else {
                    setError("Unexpected response format");
                }
                setLoading(false);
            })
            .catch(() => {
                setError("Network error");
                setLoading(false);
            });
    }, [schemeType]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    useEffect(() => {
        const handleSchemeChange = () => {
            setSchemeType(localStorage.getItem("schemeType") || "mandal");
        };
        window.addEventListener("schemeChanged", handleSchemeChange);
        return () => window.removeEventListener("schemeChanged", handleSchemeChange);
    }, []);

    const filteredUsers = users.filter((user) => {
        const name = user.full_name || "";
        const phone = user.phone || "";
        return name.includes(search) || phone.includes(search);
    });

    const totalPages = Math.ceil(filteredUsers.length / entriesPerPage) || 1;
    const paginatedUsers = filteredUsers.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h1 className="card-title" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                                        Withdrawal Details
                                    </h1>
                                    <button
                                        className="btn"
                                        onClick={() => setShowAddModal(true)}
                                        style={{
                                            backgroundColor: "#4B2C3B",
                                            borderColor: "#4B2C3B",
                                            color: "#fff",
                                        }}
                                    >
                                        <i className="fas fa-plus me-1" /> Withdraw Money
                                    </button>
                                </div>

                                <div className="card-body pt-0">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ marginTop: "1rem" }}>
                                        <div>
                                            <select
                                                value={entriesPerPage}
                                                onChange={(e) => {
                                                    setEntriesPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                                className="form-select d-inline-block w-auto"
                                            >
                                                {[5, 10, 20, 50].map((num) => (
                                                    <option key={num} value={num}>{num}</option>
                                                ))}
                                            </select>
                                            <span className="ms-2">entries per page</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control w-auto"
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {
                                                setSearch(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                            style={{ minWidth: 200 }}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        {loading ? (
                                            <div className="text-center p-4">Loading...</div>
                                        ) : error ? (
                                            <div className="alert alert-danger m-3">{error}</div>
                                        ) : (
                                            <table className="table mb-0 text-center align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>W.ID</th>
                                                        <th>Customer Name</th>
                                                        <th>Phone</th>
                                                        {schemeType === "kanchan" && <th>Total Gold (gms)</th>}
                                                        <th>Withdrawal Amount (₹)</th>
                                                        <th>Withdrawal Type</th>
                                                        <th>Withdrawal Date</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedUsers.map((user, idx) => (
                                                        <tr key={user.id || idx}>
                                                            <td>{user.id}</td>
                                                            <td><strong>{user.full_name}</strong></td>
                                                            <td>{user.phone}</td>
                                                            {schemeType === "kanchan" && (
                                                                <td>{user.withdrawal_in_gms}</td>
                                                            )}
                                                            <td>{user.withdrawal_amount}</td>
                                                            <td>{user.withdrawal_type}</td>
                                                            <td>{user.withdrawal_date}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm me-2"
                                                                    title="Edit"
                                                                    onClick={() => setEditingWithdrawalId(user.id)}
                                                                >
                                                                    <i className="far fa-edit fs-18"></i>
                                                                </button>
                                                                <DeleteWithdrawal
                                                                    withdrawalId={user.id}
                                                                    userName={user.full_name}
                                                                    onDeleteSuccess={(deletedId) =>
                                                                        setUsers((prev) => prev.filter((u) => u.id !== deletedId))
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>

                                    {!loading && !error && (
                                        <div className="d-flex justify-content-center align-items-center mt-3">
                                            <button
                                                className="btn btn-outline-secondary btn-sm me-2"
                                                disabled={currentPage === 1}
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                            >
                                                Prev
                                            </button>
                                            <span>
                                                Page {currentPage} of {totalPages}
                                            </span>
                                            <button
                                                className="btn btn-outline-secondary btn-sm ms-2"
                                                disabled={currentPage === totalPages}
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Edit Modal */}
                {editingWithdrawalId && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                        <div className={`modal-dialog modal-lg modal-dialog-centered`}>
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: "#4B2C3B", color: "white" }}>
                                    <h5 className="modal-title mb-0">Edit Withdrawal</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setEditingWithdrawalId(null)}
                                    />
                                </div>
                                <div className="modal-body">
                                    <EditWithdrawal
                                        withdrawalId={editingWithdrawalId}
                                        onClose={() => {
                                            setEditingWithdrawalId(null);
                                            fetchUsers();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Add Modal */}
                {showAddModal && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                        <div className={`modal-dialog modal-lg modal-dialog-centered`}>
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: "#4B2C3B", color: "white" }}>
                                    <h5 className="modal-title">Add Customer</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddModal(false)}
                                    />
                                </div>
                                <div className="modal-body">
                                    <AddWithdrawal
                                        onClose={() => {
                                            setShowAddModal(false);
                                            fetchUsers();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WithdrawalList;
